/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 8V6.8C7 5.11984 7 4.27976 7.32698 3.63803C7.6146 3.07354 8.07354 2.6146 8.63803 2.32698C9.27976 2 10.1198 2 11.8 2H15C16.1046 2 17 2.89543 17 4V4V4.5M12 14V16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="3"
				y="8"
				width="18"
				height="14"
				rx="4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="3"
				y="8"
				width="18"
				height="14"
				rx="4"
				fill="currentColor"
			/>
			<path
				d="M7 8V6.8C7 5.11984 7 4.27976 7.32698 3.63803C7.6146 3.07354 8.07354 2.6146 8.63803 2.32698C9.27976 2 10.1198 2 11.8 2H15C16.1046 2 17 2.89543 17 4V4V4.5M12 14V16M9.4 22H14.6C16.8402 22 17.9603 22 18.816 21.564C19.5686 21.1805 20.1805 20.5686 20.564 19.816C21 18.9603 21 17.8402 21 15.6V14.4C21 12.1598 21 11.0397 20.564 10.184C20.1805 9.43139 19.5686 8.81947 18.816 8.43597C17.9603 8 16.8402 8 14.6 8H9.4C7.15979 8 6.03968 8 5.18404 8.43597C4.43139 8.81947 3.81947 9.43139 3.43597 10.184C3 11.0397 3 12.1598 3 14.4V15.6C3 17.8402 3 18.9603 3.43597 19.816C3.81947 20.5686 4.43139 21.1805 5.18404 21.564C6.03968 22 7.15979 22 9.4 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.8 1.25H11.7679H11.7679C10.9551 1.24999 10.2994 1.24999 9.76853 1.29336C9.2219 1.33803 8.74175 1.43239 8.29754 1.65873C7.59193 2.01825 7.01825 2.59193 6.65873 3.29754C6.43238 3.74175 6.33803 4.2219 6.29336 4.76853C6.24999 5.29944 6.24999 5.95506 6.25 6.7679L6.25 6.8V7.28838C5.46558 7.33627 4.90905 7.44394 4.43404 7.68597C3.68139 8.06947 3.06947 8.68139 2.68597 9.43404C2.25 10.2897 2.25 11.4098 2.25 13.65V16.35C2.25 18.5902 2.25 19.7103 2.68597 20.566C3.06947 21.3186 3.68139 21.9305 4.43404 22.314C5.28969 22.75 6.40979 22.75 8.65 22.75H15.35C17.5902 22.75 18.7103 22.75 19.566 22.314C20.3186 21.9305 20.9305 21.3186 21.314 20.566C21.75 19.7103 21.75 18.5902 21.75 16.35V13.65C21.75 11.4098 21.75 10.2897 21.314 9.43404C20.9305 8.68139 20.3186 8.06947 19.566 7.68597C18.7103 7.25 17.5902 7.25 15.35 7.25H8.65C8.32766 7.25 8.02851 7.25 7.75 7.2513V6.8C7.75 5.94755 7.75058 5.35331 7.78838 4.89068C7.82546 4.43681 7.8946 4.17604 7.99524 3.97852C8.21095 3.55516 8.55516 3.21095 8.97852 2.99524C9.17604 2.8946 9.4368 2.82547 9.89068 2.78838C10.3533 2.75058 10.9475 2.75 11.8 2.75H15C15.6904 2.75 16.25 3.30964 16.25 4V4.5C16.25 4.91421 16.5858 5.25 17 5.25C17.4142 5.25 17.75 4.91421 17.75 4.5V4C17.75 2.48122 16.5188 1.25 15 1.25H11.8ZM12 13.25C12.4142 13.25 12.75 13.5858 12.75 14V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V14C11.25 13.5858 11.5858 13.25 12 13.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M14 8H14.5H14.6C16.8402 8 17.9603 8 18.816 8.43597C19.5686 8.81947 20.1805 9.43139 20.564 10.184C21 11.0397 21 12.1598 21 14.4V15.6C21 17.8402 21 18.9603 20.564 19.816C20.1805 20.5686 19.5686 21.1805 18.816 21.564C17.9603 22 16.8402 22 14.6 22H9.4C7.15979 22 6.03968 22 5.18404 21.564C4.43139 21.1805 3.81947 20.5686 3.43597 19.816C3 18.9603 3 17.8402 3 15.6V14.4C3 12.1598 3 11.0397 3.43597 10.184C3.81947 9.43139 4.43139 8.81947 5.18404 8.43597C6.03968 8 7.15979 8 9.4 8H9.5H10M7 8V6.8C7 5.11984 7 4.27976 7.32698 3.63803C7.6146 3.07354 8.07354 2.6146 8.63803 2.32698C9.27976 2 10.1198 2 11.8 2H15C16.1046 2 17 2.89543 17 4V4V4.5M12 14V16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 8V6.8C7 5.11984 7 4.27976 7.32698 3.63803C7.6146 3.07354 8.07354 2.6146 8.63803 2.32698C9.27976 2 10.1198 2 11.8 2H15C16.1046 2 17 2.89543 17 4V4V4.5M12 14V16M9.4 22H14.6C16.8402 22 17.9603 22 18.816 21.564C19.5686 21.1805 20.1805 20.5686 20.564 19.816C21 18.9603 21 17.8402 21 15.6V14.4C21 12.1598 21 11.0397 20.564 10.184C20.1805 9.43139 19.5686 8.81947 18.816 8.43597C17.9603 8 16.8402 8 14.6 8H9.4C7.15979 8 6.03968 8 5.18404 8.43597C4.43139 8.81947 3.81947 9.43139 3.43597 10.184C3 11.0397 3 12.1598 3 14.4V15.6C3 17.8402 3 18.9603 3.43597 19.816C3.81947 20.5686 4.43139 21.1805 5.18404 21.564C6.03968 22 7.15979 22 9.4 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.65 22.75C6.40979 22.75 5.28969 22.75 4.43404 22.314C3.68139 21.9305 3.06947 21.3186 2.68597 20.566C2.25 19.7103 2.25 18.5902 2.25 16.35V13.65C2.25 11.4098 2.25 10.2897 2.68597 9.43404C3.06947 8.68139 3.68139 8.06947 4.43404 7.68597C5.28969 7.25 6.40979 7.25 8.65 7.25H15.35C17.5902 7.25 18.7103 7.25 19.566 7.68597C20.3186 8.06947 20.9305 8.68139 21.314 9.43404C21.75 10.2897 21.75 11.4098 21.75 13.65V16.35C21.75 18.5902 21.75 19.7103 21.314 20.566C20.9305 21.3186 20.3186 21.9305 19.566 22.314C18.7103 22.75 17.5902 22.75 15.35 22.75H8.65Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.75 4C17.75 2.48122 16.5188 1.25 15 1.25H11.8H11.7679C11.1583 1.24999 10.6371 1.24999 10.1906 1.26829C10.0418 1.27439 9.90126 1.28252 9.76853 1.29336C9.2219 1.33803 8.74175 1.43239 8.29754 1.65873C8.29478 1.66013 8.29203 1.66154 8.28927 1.66295C7.58745 2.02273 7.01685 2.59468 6.65873 3.29754C6.63043 3.35306 6.6042 3.40915 6.57987 3.46586C6.40957 3.86283 6.33244 4.29023 6.29336 4.76853C6.28794 4.8349 6.2832 4.90321 6.27905 4.97353C6.24999 5.4658 6.24999 6.05665 6.25 6.76788V6.7679V6.8V8C6.25 8.02589 6.25131 8.05147 6.25387 8.07668C6.29228 8.45487 6.61168 8.75 7 8.75C7.41421 8.75 7.75 8.41421 7.75 8V6.8C7.75 5.94755 7.75058 5.35331 7.78838 4.89068C7.82547 4.4368 7.8946 4.17604 7.99524 3.97852C8.21095 3.55516 8.55516 3.21095 8.97852 2.99524C9.17604 2.8946 9.43681 2.82547 9.89068 2.78838C10.3533 2.75058 10.9475 2.75 11.8 2.75H15C15.6904 2.75 16.25 3.30964 16.25 4V4.5C16.25 4.52589 16.2513 4.55147 16.2539 4.57668C16.2923 4.95488 16.6117 5.25 17 5.25C17.4142 5.25 17.75 4.91421 17.75 4.5V4ZM12.75 14C12.75 13.5858 12.4142 13.25 12 13.25C11.5858 13.25 11.25 13.5858 11.25 14V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V14Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
